<template>
  <v-layout
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-progress-linear :value="currentProgress"></v-progress-linear>

<!--        <v-card-text>-->
<!--          <h3 :style="titleStyle">{{ $t('wait_processing_order') }}</h3>-->
<!--        </v-card-text>-->

        <v-card-text v-if="currentProgressStatus === 0">
          <!-- gzf 2022-8-2 -->
          <h3 :style="titleStyle" v-if="rid != 777">{{ $t('wait_processing_order') }}</h3>
          <div :style="titleStyle" style="text-align:center;margin-top:20px;" v-if="(currentProgressStatus !== 0 || currentProgressStatus !== 100) && rid == 1008">
            <div style="margin-top:10px">
              <v-icon style="font-size: 60px;">fas fa-circle-notch fa-spin large</v-icon>
            </div>
            <h3 style="margin-top:10px">Processing {{ curremtProgressMessage }}</h3>
            <h3 style="margin-top:10px">Please do not close this page</h3>
            <h3 style="margin-top:10px">If you see this page longer than 1 minute, please contact ourstaff.</h3>
          </div>

        </v-card-text>
        <v-card-text v-else-if="currentProgressStatus === -1">
          <h3 :style="titleStyle">{{ $t('submit_fail') }}</h3>
          <v-btn
            block
            dark
            large
            class="btn"
            :color="theme.btn_color_primary"
            @click="goBack"
          >
            <v-layout row>
              <v-flex
                xs12
                class="text-xs-center"
              >
                Go back
              </v-flex>
            </v-layout>
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- gzf 2022-8-2 -->
      <v-card
        flat
        v-if="currentProgressStatus === 1"
        class="mx-auto"
        elevation="0"
        style="width:95%;margin-top:50px;text-align:center;"
      >
        <div style="position: relative;top:-40px;">
          <div style="margin-top:10px;display: flex;justify-content: center;">
            <div style="color:#fff;background-color:#54ab7b;width:90px;height:90px;text-align:center;font-size:60px;border-radius: 50%;line-height: 90px;">✓</div>
          </div>
          <div style="color:#54ab7b;font-size:1.6rem;text-align:center;">Order Submitted</div>
          <v-card-text>
            <div style="color:rgba(0,0,0,.5);font-size:.9rem;">Your order has been submitted success</div>
          </v-card-text>
        </div>
      </v-card>
      <v-card
        flat
        v-if="currentProgressStatus === -1"
        class="mx-auto"
        elevation="0"
        style="width:95%;margin-top:50px;text-align:center;"
      >
        <div style="position: relative;top:-45px;">
          <div style="margin-top:10px;display: flex;justify-content: center;">
            <div style="color:#fff;background-color:#B22222;width:90px;height:90px;text-align:center;font-size:60px;border-radius: 50%;line-height: 90px;">✘</div>
          </div>
          <div style="color:rgba(0,0,0,.5);font-size:1.6rem;text-align:center;padding-top:10px">Order Submit Failed</div>
          <v-card-text>
            <div style="color:rgba(0,0,0,.5);font-size:.9rem;">{{ submitFailedMessage }}</div>
          </v-card-text>
        </div>
      </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { checkAvailableSchema } from '../store/modules/menu'

export default {
  data: function () {
    return {
      currentProgress: 0,
      currentProgressStatus: 0,
      submitFailedMessage: null,
    };
  },
  computed: {
    ...mapGetters('auth', [
      'user', 'addresses'
    ]),
    ...mapGetters('config', [
      'theme', 'enableZeroPrice', 'mode', 'payWithPayNow', 'enableMemberPoints', 'posType',
      'paymentModes', 'noPaymentModes', 'allowCheckout', 'allowLogin',
      'allPaymentModesLength', 'rid', 'holidays', 'gid'
    ]),
    ...mapGetters('member', [
      'profile', 'isMember'
    ]),
    ...mapGetters('order', [
      'activeOrder', 'orders', 'paymentMode', 'orderMsg',
    ]),
    ...mapGetters('delivery', [
      'address'
    ]),
    ...mapGetters('cart', [
      'cart', 'cartAmount', 'pickupDate', 'pickupTime', 'cartMsg', 'vouchers','discountInfo',
      'discountInfoIsFilled',
    ]),
    ...mapGetters('menu', [
      'catListIds'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
  },
  methods: {
    changeCurrentProgress(value) {
      this.currentProgress = value;

      if (value === 100) {
        this.currentProgressStatus = 1;
      }
    },
    changeCurrentProgressMessage(value) {
      this.curremtProgressMessage = value;
    },
    makeCurrentProgressStatusToFail(message) {
      this.currentProgressStatus = -1;
      this.submitFailedMessage = message;
    },
    goBack() {
      this.$router.push('cart');
    }
  },
  async created () {
    // This function might takes long to load, so add a loading indicator
    // this.$bus.$emit('showFullLoading', true)

    this.changeCurrentProgress(5);
    this.changeCurrentProgressMessage('check items...');

    // Check availability schema
    await this.$store.dispatch('menu/fetchMenuCats')
    const notAvailableItems = []
    this.cart.forEach(item => {
      if (!item.is_promo && !this.catListIds.includes(item.category_id) && !item.member_voucher_id) {
        notAvailableItems.push(item.name)
      }
    })

    this.changeCurrentProgress(10);


    for (const item of this.cart) {
      const currentMode = this.mode
      const date = currentMode.isTakeaway || currentMode.isDelivery ? this.pickupDate : null
      const time = currentMode.isTakeaway || currentMode.isDelivery ? this.pickupTime : null
      const selectedDateTime = date && time ? date + ' ' + time : null
      const timeData = await axios.post('/api/moment/current', {
        holidays: this.holidays,
        date: selectedDateTime
      })
      const currentTime = timeData.data
      const setCourseItems = item.set_course_items.length > 0 ? item.set_course_items : null
      await axios.post('/api/menu/cat/items', {
        restaurant_id: parseInt(this.rid),
        category_id: item.category_id,
        date: date,
        time: time
      }).then(response => {
        if (!response.data.find(i => i.item_id === item.item_id)) {
          notAvailableItems.push(item.name)
        }
        else {
          let category_item = response.data.find(i => i.item_id === item.item_id)
          // if cart item has set course items
          if (parseInt(this.gid) === 256 && setCourseItems !== null) {
            // check cart item's course item id includes in category item's course item id
            let valid_course_item_ids = []
            category_item.courses.forEach(cc => {
              cc.course_items.forEach(ccc => { valid_course_item_ids.push(ccc.course_item_id) })
            })

            setCourseItems.forEach(sci => {
              if (!valid_course_item_ids.includes(sci.setCourseItemID)) { notAvailableItems.push(item.name) }
            })
          }

          if (checkAvailableSchema(category_item.avail_schema, currentTime) !== 0) notAvailableItems.push(item.name)
        }
      })

      this.changeCurrentProgress(10 + ((this.cart.indexOf(item) + 1) * parseInt(30 / this.cart.length)))
    }

    if (notAvailableItems.length > 0) {
      // this.$router.push({ name: 'cart'})
      //
      // this.$store.dispatch('responseMessage', {
      //   type: 'error',
      //   title: this.$t('item_unavailable'),
      //   text: 'The following item(s) is unavailable:' + notAvailableItems.join(', '),
      //   modal: true
      // })

      this.makeCurrentProgressStatusToFail(
        'The following item(s) is unavailable:' + notAvailableItems.join(', ')
      );

      // this.$bus.$emit('showFullLoading', false)
      return
    }

    this.changeCurrentProgress(50);

    await this.$store.dispatch('cart/checkCartItems')
    if (this.cartMsg) {
      // this.$router.push({ name: 'cart'})

      // this.$store.dispatch('responseMessage', {
      //   type: 'error',
      //   title: 'Unable to submit',
      //   text: this.cartMsg,
      //   modal: true
      // })

      this.makeCurrentProgressStatusToFail(
        this.cartMsg
      );
      // this.$bus.$emit('showFullLoading', false)
      return
    }

    this.changeCurrentProgress(60);
    this.changeCurrentProgressMessage('check submit...');

    if (this.posType === 0) {
      await this.$store.dispatch('order/checkSubmitOrder')
    } else {
      await this.$store.dispatch('order/checkSubmitOrder2')
    }

    this.changeCurrentProgress(70);

    // this.$bus.$emit('showFullLoading', false)

    if (this.orderMsg) {
      let message = 'Unable to submit';
      if (this.orderMsg == 'Restaurant is closed') {
        message = this.orderMsg
      }
      this.makeCurrentProgressStatusToFail(message);

      // this.$router.push({ name: 'cart'})
      //
      // this.$store.dispatch('responseMessage', {
      //   type: 'error',
      //   title: 'Unable to submit',
      //   text: this.orderMsg,
      //   modal: true
      // })

      return;
    } else {
      const itemVouchers = this.vouchers.filter(v => v.voucher_type === 1)
      // mark voucher as used
      if (itemVouchers.length > 0) {
        itemVouchers.forEach(v => {
          axios.post('/api/voucher/used', {
            memberID: this.profile.loyalty_member_id,
            voucher_id: v.member_voucher_id,
            group_id: this.gid
          })
        })
      }
      // this.$router.push({ name: 'submit' })
    }

    this.changeCurrentProgress(90);
    this.changeCurrentProgressMessage('submit order...');

    if (!this.activeOrder) {
      this.$router.replace({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    }

    await this.$store.dispatch('order/addUnpaidOrder')

    this.changeCurrentProgress(95);

    const id = this.activeOrder.id
    if (this.mode.isDelivery && this.user && !this.address.id && this.addresses && this.addresses.length < 3) {
      // Save only if address in used is not from user's addresses and there is no exact same postal code already exist
      const i = this.addresses.findIndex(a => a.postal_code === this.address.postal_code)
      if (i === -1) {
        this.$store.dispatch('auth/addAddress', this.address)
      }
    }
    this.$store.dispatch('order/disableUsePoints')
    if (this.mode.isDinein) {
      this.$store.dispatch('changeTable', '')
    }
    // Only reset if there are multiple outlets
    // if (this.restaurants && this.restaurants.length > 1) {
    //   this.$store.dispatch('config/changeRid', 0)
    // }
    await this.$store.dispatch('order/fetchActiveMobileOrderStatus')
    this.$store.dispatch('order/resetTransid')
    this.$store.dispatch('cart/resetCart')
    this.$store.dispatch('cart/resetPickupTime')
    this.$store.dispatch('takeaway/resetContact')
    this.$store.dispatch('removeAllDiscountVoucher')

    this.changeCurrentProgress(100);
    this.changeCurrentProgressMessage('order submitted');

    setTimeout(() => {

      if (this.paymentMode && this.paymentMode.code === 'paynow') {
        this.$store.dispatch('order/resetPaymentMode')
        this.$router.replace({ name: 'paynow_instruction' })
      } else if (this.paymentMode && this.paymentMode.code === 'pay_at_counter') {
        this.$store.dispatch('order/resetPaymentMode')
        this.$router.replace({ name: 'pay_at_counter_instruction' })
      } else {
        this.$store.dispatch('order/resetOrder')
        if (this.orders.find(o => parseInt(o.id) === parseInt(id))) {
          this.$router.replace({ name: 'order2', params: { id: id.toString() }})
        } else {
          this.$router.replace({ name: 'orders' })
        }
      }

    }, 1300);
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/submit.vue